<template>
  <SmallSquare content="可查看每家门店的核销情况" :padding='true' />
  <a-card :bordered="false">
    <a-tabs v-model:activeKey="activeKey" @change='tabChange'>
      <a-tab-pane :key="1" tab="订单积分" :disabled='activeKey !== 1 && listLoading'></a-tab-pane>
      <a-tab-pane :key="2" tab="线下积分核销" :disabled='activeKey !== 2 && listLoading'></a-tab-pane>
      <a-tab-pane :key="3" tab="优惠券" :disabled='activeKey !== 3 && listLoading'></a-tab-pane>
      <a-tab-pane :key="4" tab="礼品" :disabled='activeKey !== 4 && listLoading'></a-tab-pane>
      <a-tab-pane :key="5" tab="核销奖励" :disabled='activeKey !== 5 && listLoading'></a-tab-pane>
      <!-- 新 -->
      <a-tab-pane :key="6" tab="会员卡礼品" :disabled='activeKey !== 6 && listLoading'></a-tab-pane>
    </a-tabs>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keywords'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.keyword_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="4" v-if='activeKey == 2'>核销人</a-select-option>
            <a-select-option :value="1">核销门店</a-select-option>
            <a-select-option :value="2">所属上级</a-select-option>
            <a-select-option :value="3" v-if='activeKey == 4'>商品名称</a-select-option>
            <a-select-option :value="activeKey == 4 ? 4 : 3" v-if='activeKey == 1 || activeKey == 4'>订单号</a-select-option>
            <a-select-option :value="3" v-if='activeKey == 3'>优惠券名称</a-select-option>
            <a-select-option :value="4" v-if='activeKey == 3'>券码</a-select-option>
            <!-- 新 -->
             <a-select-option :value="5" v-if='activeKey == 6'>礼品名称</a-select-option>
             <a-select-option :value="6" v-if='activeKey == 6'>权益卡名称</a-select-option>
            <!--  -->
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
        </a-input-group>
      </a-form-item>
      <a-form-item label="" name='type' >
        <!-- 礼品 -->
        <a-select v-model:value="search.exchange_type" :style="{width:'180px'}" placeholder="请选择" v-if='activeKey == 4'>
          <a-select-option value="">全部来源</a-select-option>
          <a-select-option :value="1">产品权益</a-select-option>
          <a-select-option :value="5">扫码奖品</a-select-option>
          <a-select-option :value="4">礼品派发</a-select-option>
        </a-select>
        <!-- 礼品 -->
        <a-select v-model:value="search.source_type" :style="{width:'180px'}" placeholder="请选择" v-if='activeKey == 3 || activeKey == 5'>
          <!-- <a-select-option value="" v-if='activeKey == 1'>全部订单来源</a-select-option>
          <a-select-option value="" v-if='activeKey == 2'>全部积分来源</a-select-option>
          <a-select-option :value="1" v-if='activeKey == 1 || activeKey == 2'>云店普通订单</a-select-option>
          <a-select-option :value="2" v-if='activeKey == 1 || activeKey == 2'>秒杀订单</a-select-option>
          <a-select-option :value="3" v-if='activeKey == 1 || activeKey == 2'>拼团订单</a-select-option>
          <a-select-option :value="5" v-if='activeKey == 1 || activeKey == 2'>积分商城订单</a-select-option>
          <a-select-option :value="4" v-if='activeKey == 1 || activeKey == 2'>直播订单</a-select-option> -->
          <!-- 优惠券 -->
          <a-select-option value="" v-if='activeKey == 3'>全部渠道</a-select-option>
          <a-select-option :value="1" v-if='activeKey == 3'>会员权益</a-select-option>
          <a-select-option :value="3" v-if='activeKey == 3'>直接发放</a-select-option>
          <a-select-option :value="4" v-if='activeKey == 3'>扫码活动</a-select-option>
          <a-select-option :value="5" v-if='activeKey == 3'>云店派券活动</a-select-option>
          <a-select-option :value="6" v-if='activeKey == 3'>优惠券礼包</a-select-option>
          <a-select-option :value="2" v-if='activeKey == 3'>品牌派券活动</a-select-option>
          <!-- 优惠券 -->
          <!-- 核销奖励 -->
          <a-select-option value="" v-if='activeKey == 5'>全部完成核销奖励</a-select-option>
          <a-select-option :value="1" v-if='activeKey == 5'>订单积分核销奖励</a-select-option>
          <a-select-option :value="2" v-if='activeKey == 5'>线下积分核销奖励</a-select-option>
          <a-select-option :value="3" v-if='activeKey == 5'>优惠券核销奖励</a-select-option>
          <a-select-option :value="4" v-if='activeKey == 5'>礼品核销奖励</a-select-option>
          <!-- 核销奖励 -->
        </a-select>
      </a-form-item>
      <a-form-item :label="activeKey == 5 ?'完成时间':'核销时间'" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
        <a-button type="primary" ghost class="m-l-15" v-has:storeWriteExport="()=>{exportMember()}">导出</a-button>
      </a-form-item>
    </a-form>
    <tables :listLoading='listLoading' :columns='columns' :data='data' :keyRow='keyRow' v-if='!listLoading'></tables>
    <a-spin tip="加载中..." v-else>
      <div class="width100 height-150"></div>
    </a-spin>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getWriteOrderPoint,getWriteCoupon,getWriteGift,writeList } from "@/api/reimbursement";
  import tables from './tables'
  // 初始化默认筛选项数值
  let defSearch = {
    keyword_type:'',
    keyword:'',
    source_type:'',
    exchange_type:'',
    start_write_off_time:'',
    end_write_off_time:'',
    page:1,
    limit:10
  }
  export default {
    components: { tables },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading:false,
        columns:[],
        data:[],
        keyRow:'',
        activeKey:1,
        time:[],
        total:0,
        ordercolumns:[
          {
            title: "核销门店",
            dataIndex: "store_name",
            key: "store_name",
          },
          {
            title: "所属上级",
            dataIndex: "parent_name",
            key: "parent_name",
          },
          {
            title: "订单号",
            dataIndex: "order_no",
            key: "order_no",
          },
          {
            title: "订单来源",
            dataIndex: "source_type",
            key: "source_type",
          },
          {
            title: "积分数量",
            dataIndex: "point",
            key: "point"
          },
          {
            title: "核销时间",
            dataIndex: "write_off_time",
            key: "write_off_time",
          },
        ],
        piontcolumns:[
          {
            title: "核销人",
            dataIndex: "write_off_name",
            key: "write_off_name",
          },
          {
            title: "核销门店",
            dataIndex: "store_name",
            key: "store_name",
          },
          {
            title: "所属上级",
            dataIndex: "parent_name",
            key: "parent_name",
          },
          {
            title: "用户ID",
            dataIndex: "user_id",
            key: "user_id",
          },
          {
            title: "积分数量",
            dataIndex: "point",
            key: "point"
          },
          {
            title: "核销时间",
            dataIndex: "write_off_time",
            key: "write_off_time",
          },
        ],
        couponcolumns:[
          {
            title: "核销门店",
            dataIndex: "store_name",
            key: "store_name",
          },
          {
            title: "所属上级",
            dataIndex: "parent_name",
            key: "parent_name",
          },
          {
            title: "优惠券名称",
            dataIndex: "coupon_name",
            key: "coupon_name",
          },
          {
            title: "券码",
            dataIndex: "coupon_sn",
            key: "coupon_sn",
          },
          {
            title: "发放渠道",
            dataIndex: "source_type",
            key: "source_type",
          },
          {
            title: "核销时间",
            dataIndex: "write_off_time",
            key: "write_off_time",
          },
        ],
        giftcolumns:[
          {
            title: "核销门店",
            dataIndex: "store_name",
            key: "store_name",
          },
          {
            title: "所属上级",
            dataIndex: "parent_name",
            key: "parent_name",
          },
          {
            title: "礼品名称",
            dataIndex: "exchange_name",
            key: "exchange_name",
            slots: { customRender: "exchange_name" },
          },
          {
            title: "订单号",
            dataIndex: "order_no",
            key: "order_no",
          },
          {
            title: "礼品来源",
            dataIndex: "exchange_type",
            key: "exchange_type",
          },
          {
            title: "核销时间",
            dataIndex: "write_off_time",
            key: "write_off_time",
          },
        ],
        rewardcolumns:[
          {
            title: "核销门店",
            dataIndex: "store_name",
            key: "store_name",
          },
          {
            title: "所属上级",
            dataIndex: "parent_name",
            key: "parent_name",
          },
          {
            title: "完成核销奖励",
            dataIndex: "source_type",
            key: "source_type",
          },
          {
            title: "完成时间",
            dataIndex: "write_off_time",
            key: "write_off_time",
          },
          {
            title: "核销奖励",
            dataIndex: "point",
            key: "point",
            slots: { customRender: "point" },
          }
        ],
        //新
        cardColumns:[
           {
            title: "核销门店",
            dataIndex: "write_store_name",
            key: "write_store_name",
          },
         {
            title: "所属上级",
            dataIndex: "dealer_name",
            key: "dealer_name",
          },
            {
            title: "礼品名称",
            dataIndex: "exchange_name",
            key: "exchange_name",
            slots: { customRender: "member_gift" },
          },
          {
            title: "权益卡名称",
            dataIndex: "card_name",
            key: "card_name",
          },
          {
            title: "核销时间",
            dataIndex: "receive_time",
            key: "receive_time",
          },
        ]
      });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        getList();
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        getList();
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        getList();
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_write_off_time = e[0]
        search.value.end_write_off_time = e[1]
      }
      // 获取积分订单
      const getOrderPoint = async () => {
        state.listLoading = true;
        let res = await getWriteOrderPoint({...search.value,type:state.activeKey == 5 ? 3 : (state.activeKey == 2 ? 4 : state.activeKey)}).then((res) => res.data).catch(error=>error);
        if (iscode(res)) {
          state.data = res.data.data;
          state.total = res.data.total
        } else {
          message.error(res.msg);
        }
        setTimeout(()=>{
          state.listLoading = false;
        },100)
      };
      // 获取优惠券
      const getCoupon = async () => {
        state.listLoading = true;
        let res = await getWriteCoupon(search.value).then((res) => res.data).catch(error=>error);
        if (iscode(res)) {
          state.data = res.data.data;
          state.total = res.data.total
        } else {
          message.error(res.msg);
        }
        setTimeout(()=>{
          state.listLoading = false;
        },100)
      };
      // 获取礼品
      const getGift = async () => {
        state.listLoading = true; 
        let res = await getWriteGift(search.value).then((res) => res.data).catch(error=>error);
        if (iscode(res)) {
          state.data = res.data.data;
          state.total = res.data.total
        } else {
          message.error(res.msg);
        }
        setTimeout(()=>{
          state.listLoading = false;
        },100)
      };
      //切换面板
      const tabChange = (e) =>{
        search.value = {...defSearch}
        getList();
      }
      const getList = () =>{
        let columns,keyRow;
        state.data=[];
        state.total = 0;
        if(state.activeKey == 1){
          columns = state.ordercolumns
          keyRow = 'order_no'
          getOrderPoint()
        }
        if(state.activeKey == 2){
          columns = state.piontcolumns
          keyRow = 'user_id'
          getOrderPoint()
        }
        if(state.activeKey == 3){
          columns = state.couponcolumns
          keyRow = 'coupon_sn'
          getCoupon()
        }
        if(state.activeKey == 4){
          columns = state.giftcolumns
          keyRow = 'order_no'
          getGift()
        }
        if(state.activeKey == 5){
          columns = state.rewardcolumns
          keyRow = 'order_no'
          getOrderPoint()
        }
        if(state.activeKey == 6){
          columns = state.cardColumns,
           keyRow = 'id'
           getMemberGift()
        }
        state.columns = columns
        state.keyRow = keyRow
      }

      const getMemberGift = async function(){

          state.listLoading = true;
         let res = await writeList({...search.value}).then(res=>res.data)
          state.listLoading = false;
         if(iscode(res)){
             state.data = res.data.data || [];
             state.total = res.data.total;
         }else{
           message.error(res.msg)
         }
      }
      const exportMember =async function(){
        const hide = message.loading('正在加载中...', 0);
        let result = await writeList({...search.value,excel:1}).then(res=>res.data)
         if(iscode(result,true)){
          window.open(result.data.action)
          }
         setTimeout(hide);
      }

      const exportTable = async function(){
         const hide = message.loading('正在加载中...', 0);
         let result;
         if(state.activeKey !=3 && state.activeKey !=4){
           console.log({...search.value,excel:1},'222')
            result = await getWriteOrderPoint({...search.value,excel:1,type:state.activeKey == 5 ? 3 : (state.activeKey == 2 ? 4 : state.activeKey)}).then(res=>res.data).catch(error=>error);
         }else if(state.activeKey ==3){
            result = await getWriteCoupon({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
         }else if(state.activeKey ==4){
               result = await getWriteGift({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
         }
        if(iscode(result,true)){
          window.open(result.data.action)
        }
        setTimeout(hide);
      }
      onMounted(() => {
        getList();
      });
      return {
        search,
        ...toRefs(state),
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange,
        tabChange,
        exportTable,
        exportMember
      };
    },
  };
</script>
<style>
  .ant-tabs-nav .ant-tabs-tab-disabled, .ant-tabs-nav .ant-tabs-tab-disabled:hover{
    color: #000
  }
</style>